<template>
  <div
    class="_image _designer-element"
    :class="isActive ? 'active' : ''"
    :id="data.id"
    :style="getStyle"
    @dblclick="startEditing"
    @click="setActiveItem"
  >
    <img :src="data.content" style="width: 100%; height: 100%;" :style="{borderRadius: data.radius != null && data.radius != undefined ? data.radius+'% !important' : '0% !important','-webkit-border-radius':data.radius != null && data.radius != undefined ? data.radius+'% !important' : '0% !important','-moz-border-radius':data.radius != null && data.radius != undefined ? data.radius+'% !important' : '0% !important',borderWidth:2,borderStyle:'solid',borderColor:'transparent'}" alt="" />
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "DesignerImage",
  props: ["data", "isActive"],
  directives: {
    ClickOutside
  },
  methods: {
    startEditing() {
      this.$emit("StartEditing", this.data.id);
    },
    stopEditing() {
      this.$emit("StopEditing", this.data.id);
    },
    setActiveItem() {
      this.$emit("SetActiveElement", this.data.id);
    }
  },
  computed: {
    getStyle() {
      return {
        ...this.data,
        fontSize: this.data.fontSize + "px",
        width: this.data.width + "px",
        height: this.data.height + "px",
        left: this.data.left + "px",
        top: this.data.top + "px",
      };
    }
  },
  mounted() {
    $("#" + this.data.id).draggable({
      smartguides: "._designer-element",
      containment: "#_canvas",
      tolerance: 5,
      scroll: false,
      stop: (element, position) => {
        this.$emit("PositionUpdated", { position, id: this.data.id });
      }
    });

    $("#" + this.data.id).resizable({
      containment: "#_canvas",
      stop: (element, size) => {
        this.$emit("SizeUpdated", { size, id: this.data.id });
      }
    });
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/DesignerImage.vue